/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ads_Dialog_Listing_LabelInputs */

const en_directory_ads_dialog_listing_label = /** @type {(inputs: Directory_Ads_Dialog_Listing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing to promote`)
};

const zh_directory_ads_dialog_listing_label = /** @type {(inputs: Directory_Ads_Dialog_Listing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要推广的 listing`)
};

/**
* | output |
* | --- |
* | "Listing to promote" |
*
* @param {Directory_Ads_Dialog_Listing_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ads_dialog_listing_label = /** @type {((inputs?: Directory_Ads_Dialog_Listing_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ads_Dialog_Listing_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ads_dialog_listing_label(inputs)
	return zh_directory_ads_dialog_listing_label(inputs)
});
export { directory_ads_dialog_listing_label as "directory.ads.dialog_listing_label" }